import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  TASK_FORM_TITLE_FIELD_MAX_LENGTH,
  TASK_FORM_TITLE_FIELD_NAME,
} from '../../TaskForm.constants'

function TitleField(props) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      {...props}
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Task.FormTitleFieldLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={TASK_FORM_TITLE_FIELD_MAX_LENGTH}
      name={TASK_FORM_TITLE_FIELD_NAME}
      placeholder={t('Task.FormTitleFieldPlaceholderKey')}
    />
  )
}

export default TitleField
